// «Настройки» (007; ux.md «Табеля», раздел 11): общий каркас разделов — навигация слева, раздел
// справа. Маршрут без своего адреса: разделы сохраняют адреса (/users, /audit, /profile…), новые
// разделы — под /settings/…. Крошки: «Настройки / <раздел>».
import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '../../shell/SettingsLayout.tsx';

export const Route = createFileRoute('/_app/_settings')({
  staticData: { crumb: 'Настройки' },
  component: SettingsLayout,
});
